import type {
  AsYouType,
  CountryCode,
  getCountryCallingCode,
  isValidPhoneNumber,
  parsePhoneNumberFromString,
  validatePhoneNumberLength,
} from "libphonenumber-js"

export type PhoneNumberLib = {
  AsYouType: typeof AsYouType
  validatePhoneNumberLength: typeof validatePhoneNumberLength
  getCountryCallingCode: typeof getCountryCallingCode
  isValidPhoneNumber: typeof isValidPhoneNumber
  parsePhoneNumberFromString: typeof parsePhoneNumberFromString
}

export type { CountryCode }

let cached: Promise<PhoneNumberLib> | null = null

export function loadPhoneNumberLib(): Promise<PhoneNumberLib> {
  if (!cached) {
    cached = import("libphonenumber-js").then((mod) => ({
      AsYouType: mod.AsYouType,
      validatePhoneNumberLength: mod.validatePhoneNumberLength,
      getCountryCallingCode: mod.getCountryCallingCode,
      isValidPhoneNumber: mod.isValidPhoneNumber,
      parsePhoneNumberFromString: mod.parsePhoneNumberFromString,
    }))
  }
  return cached
}
